import React from 'react';

interface EyeIconProps {
  className?: string;
}

function EyeIcon({ className }: EyeIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" className={className}>
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" clipPath="url(#clip0)">
        <path d="M.667 8.285S3.333 2.952 8 2.952c4.666 0 7.333 5.333 7.333 5.333S12.666 13.62 8 13.62C3.333 13.62.667 8.286.667 8.286z"></path>
        <path d="M8 10.285a2 2 0 100-4 2 2 0 000 4z"></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h16v16H0z" transform="translate(0 .285)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default EyeIcon;
